import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
import { faqsData } from '../../mock';
import { fadeUp, staggerContainer, viewport } from '../../lib/motion';

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section className="px-6 lg:px-10 py-28 bg-ink-900">
      <div className="max-w-3xl mx-auto">
        <motion.div variants={staggerContainer()} initial="hidden" whileInView="show" viewport={viewport} className="text-center mb-14">
          <motion.span variants={fadeUp} className="text-xs tracking-[0.2em] uppercase font-semibold text-gold-light">Got Questions?</motion.span>
          <motion.h2 variants={fadeUp} className="font-display text-4xl sm:text-5xl text-white tracking-tight mt-3">Frequently Asked Questions</motion.h2>
        </motion.div>

        <motion.div variants={staggerContainer(0.08)} initial="hidden" whileInView="show" viewport={viewport} className="space-y-3">
          {faqsData.map((faq, i) => {
            const isOpen = openIdx === i;
            return (
              <motion.div key={i} variants={fadeUp} data-testid={`faq-item-${i}`} className="bg-ink-800 border border-slate-800 rounded-2xl overflow-hidden">
                <button
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  data-testid={`faq-toggle-${i}`}
                  className="w-full flex items-center justify-between gap-4 p-6 text-left"
                >
                  <span className="font-display text-lg text-white">{faq.question}</span>
                  <Plus className={`w-5 h-5 text-gold-light shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} strokeWidth={1.5} />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                    >
                      <p className="text-slate-400 text-sm leading-relaxed px-6 pb-6">{faq.answer}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
